import React from 'react';

import { useHistory } from 'react-router-dom';

import PasswordResetSuccess from '../../components/passwordResetSuccess/PasswordResetSuccess';

export default () => {
  const history = useHistory();
  const onLogin = () => history.push('/login');

  return <PasswordResetSuccess onLogin={onLogin} />;
};
